<template>
<div>
  <div v-if="review.checkForPhotos">
    <span class="spinner-border spinner-border-mg"></span>
    <span class="">Loading reviews...</span>
  </div>
  <div class="row" v-if="filteredPhotos.length">
    <div class="col-12 my-2">
      <div class="image-set d-flex">
        <ReviewPhoto v-for="photo in filteredPhotos"
          :key="photo.id"
          :photo="photo"
          :title="`${review.user.title} photo ${review.photos.indexOf(photo) + 1}`" />

        <button class="btn btn-secondary"
          style="height:100px !important; max-width: 30%; width:100px;"
          @click="showMorePhotos = !showMorePhotos"
          v-if="showMoreButton">View {{ showMorePhotos ? 'less' : 'more' }} ({{review.photos.length}})
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ReviewPhoto from './ReviewPhoto.vue';

export default {
  data() {
    return {
      showMorePhotos: false,
      previewPhotoCount: 4,
    };
  },
  components: {
    ReviewPhoto,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showMoreButton() {
      return this.review.photos.length > this.previewPhotoCount;
    },
    filteredPhotos() {
      if (this.showMorePhotos) {
        return this.review.photos;
      }

      return this.review.photos.slice(0, this.previewPhotoCount);
    },
  },
};
</script>
